import * as React from 'react';
import {Divider, Typography} from 'antd';
import moment from 'moment';
import Flex from '../Flex';
const {Text} = Typography;

export default function PageFooter() {
  return (
    <div className={'pageFooter'}>
      <div className={'pageFooterContainer'}>
        <Flex style={{padding: '0 30px'}}>
          <Flex>
            {/*<Flex>*/}
            {/*  <img alt={'logo'} src={'/images/scs-logo-white.png'} style={{height: 100}} />*/}
            {/*</Flex>*/}
            <div style={{color: '#a5aabd', marginLeft: 30, textAlign: 'left'}}>
              <div>上海市宇航学会 &copy; 2016-{moment().format('YYYY')} All Rights Reserved</div>
              <a href="http://beian.miit.gov.cn" target={'_blank'}>
                沪ICP备16054006号
              </a>
              <div>地址：上海市漕溪路222号航天大厦南楼1304～1306室</div>
              <div>E-mail：shhas63295054@126.com</div>
            </div>
          </Flex>
          {/*<img src="/images/wechat.jpg" alt="wechat" style={{height: 120}} />*/}
        </Flex>
      </div>
    </div>
  );
}
